import React from "react";
import "./sitemap.css";
const publicPath = "http://localhost:3000";

export default function SiteMap() {
  const data = [
    {
      h3title: "Main Page Links",
      data: [
        {
          link: "Home",
          to: `${publicPath}/`,
        },
        {
          link: "About",
          to: `${publicPath}/#about-scrobits`,
        },
        {
          link: "Portfolio",
          to: `${publicPath}/#portfolio`,
        },
        {
          link: "Services",
          to: `${publicPath}/#services`,
        },
        {
          link: "Contact Us",
          to: `${publicPath}/#contact-us`,
        },
        {
          link: "Career",
          to: `${publicPath}/#career`,
        },
        {
          link: "Get Started",
          to: `${publicPath}/get-quote`,
        },
      ],
    },
    {
      h3title: "Quote's link's",
      data: [
        {
          link: "Product 1",
          to: `${publicPath}/quote/product-1`,
        },
        {
          link: "Product 2",
          to: `${publicPath}/quote/product-2`,
        },
        {
          link: "Product 3",
          to: `${publicPath}/quote/product-3`,
        },
        {
          link: "Product 4",
          to: `${publicPath}/quote/product-4`,
        },
      ],
    },
    {
      h3title: "Social Contact",
      data: [
        {
          link: "Linked In",
          to: `${publicPath}/social/linked-in`,
        },
        {
          link: "Insta",
          to: `${publicPath}/social/insta-id`,
        },
        {
          link: "E-mail",
          to: `${publicPath}/social/e-mail`,
        },
        {
          link: "Location",
          to: `${publicPath}/social/google-map`,
        },
      ],
    },
    {
      h3title: "Company Contact",
      data: [
        {
          link: "Terms &amp; Conditions",
          to: `${publicPath}/Company/terms-condition`,
        },
        {
          link: "Privacy Policy",
          to: `${publicPath}/Company/privacy-policy`,
        },
        {
          link: "Contact Us",
          to: `${publicPath}/company/contact-details`,
        },
      ],
    },
  ];

  return (
    <div className="section__margin">
      <div className="scrobits__sitemap-inner_container">
        {data.map((card) => {
          return (
            <div className="scrobits__sitemap-card">
              <p className="scrobits__sitemap-title">{card.h3title}</p>
              <ul className="scrobits__sitemap-links__container">
                {card.data.map((links) => {
                  return (
                    <li>
                      <a href={links.to}>{links.link}</a>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
}
